import React, { useState, useEffect, useRef } from "react";

//design imports from material
import {
  Grid,
  FormLabel,
  TextField,
  Typography,
  Button,
  FormControl,
} from "@mui/material";

//layout import
import Layout from "../../layout/Layout";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";

//form imports
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import StateList, { stateList } from "../../components/StateList";

//date picker
import dayjs from "dayjs";

import axios from "axios";
import {
  config,
  manageCompaniesAPI,
  phoneRegExp,
  urlRegExp,
  trnNumber,
} from "../../config";
import { AlertMessage } from "../../components/AlertMessage";
import { useParams, useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { emirates } from "../../components/constants";

function ManageCoEdit() {
  const navigate = useNavigate();
  const { companyId } = useParams();

  const validateUaePhone = (value, isRequired = true) => {
    if (!value) return isRequired ? "Mobile Number is required" : true;

    // Remove spaces/hyphens for clean checking
    const clean = value.replace(/[\s-]/g, "");

    // Accept any country's phone number: optional leading '+', 7-15 digits
    const phoneRegex = /^\+?[0-9]{7,15}$/;
    if (!phoneRegex.test(clean)) {
      return "Enter a valid phone number";
    }

    return true; // ✅ valid
  };

  const validationSchema = Yup.object().shape({
    txtCompanyName: Yup.string().required("Company name is required"),

    txtAddress: Yup.string()
      .required("Address is required")
      .min(3, "Street Address must be at least 3 characters")
      .max(100, "Street Address cannot be more than 100 characters"),

    txtCity: Yup.string()
      .required("Town / City is required")
      .min(3, "Town / City must be at least 3 characters")
      .max(100, "Town / City cannot be more than 100 characters"),

    txtState: Yup.string()
      .required("Emirate is required")
      .min(3, "Emirate must be at least 3 characters")
      .max(100, "Emirate cannot be more than 100 characters"),

    intPincode: Yup.string().required("P.O.Box is required"),

    txtPrimaryPhoneNumber: Yup.string()
      .required("Primary Contact Number is required")
      .test("valid-uae-phone", (value, ctx) => {
        const result = validateUaePhone(value, true);
        return result === true ? true : ctx.createError({ message: result });
      }),

    // txtSecondaryPhoneNumber: Yup.string()
    // .required("Secondary Phone Number is required"),

    txtEmailId: Yup.string()
      .required("Company Email is required")
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        "Enter a valid email address"
      ),

    txtWebsiteLink: Yup.string()
      .required("Website Link is required")
      .matches(urlRegExp, "Please enter a valid website URL"),

    txtTrnNumber: Yup.string()
      .required("TRN is required")
      .matches(trnNumber, "Please enter a valid 15 digit TRN"),

    txtGstNo: Yup.string()
      .required("VAT Number is required")
      .matches(
        /^\d{15}$/,
        "VAT Number must be exactly 15 digits and numeric only"
      ),

    // bank validation
    txtBankName: Yup.string().required("Bank Name is required"),
    txtBranch: Yup.string()
      .required("BIC is required")
      .matches(
        /^[A-Z]{4}AE[A-Z0-9]{2}([A-Z0-9]{3})?$/,
        "BIC must be 8 or 11 characters: 4-letter bank code, 'AE' country code, 2-character location code, optional 3-character branch code"
      )
      .test(
        "len",
        "BIC must be either 8 or 11 characters long",
        (val) => val && (val.length === 8 || val.length === 11)
      ),
    txtAccountName: Yup.string().required("Account Holder Name is required"),
    // txtAccountNo: Yup.string().required("Account Number is required"),
    txtIfscCode: Yup.string()
      .required("IBAN Code is required")
      .matches(
        /^AE\d{2}\d{3}\d{16}$/,
        "IBAN must start with 'AE', followed by 2 digits (check digits), 3-digit bank code, and 16-digit account number"
      )
      .length(23, "IBAN must be exactly 23 characters"),
    // .min(11, "IBAN Code must be 11 digits")
    // .max(11, "IBAN Code must be 11 digits")
    // .matches(ifscCodeRegExp, "Please enter a valid IBAN Code"),
  });

  const [stateName, setStateName] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");

  const [baseImage, setBaseImage] = useState("");

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, control, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  function onSubmit(data) {
    data.intType = 2;
    data.intCompanyId = companyId;
    data.txtState = stateName;
    data.txtCoLogo = baseImage;

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = manageCompaniesAPI;
    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        setTimeout(function () {
          navigate("/manage-companies/list");
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      const data = JSON.stringify({
        intCompanyId: parseInt(companyId),
        intType: 4,
      });

      config.method = "POST";
      config.data = data;
      config.url = manageCompaniesAPI;

      axios(config)
        .then(function (response) {
          setStateName(response.data.result);
          handleFormReset(response.data.result[0]);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const handleFormReset = (data) => {
    let defaultValues = {};
    setStateName(data.emirate);
    setBaseImage(data.company_logo);
    defaultValues.txtCompanyName = data.company_name;
    defaultValues.txtAddress = data.address;
    defaultValues.txtCity = data.city;
    defaultValues.txtState = data.emirate;
    defaultValues.intPincode = data.POBoxNumber;
    defaultValues.txtPrimaryPhoneNumber = data.primary_contact;
    defaultValues.txtSecondaryPhoneNumber = data.secondary_contact;
    defaultValues.txtEmailId = data.email_id;
    defaultValues.txtWebsiteLink = data.website_link;
    defaultValues.txtGstNo = data.vat_no;
    defaultValues.txtPanNo = data.pan_no;
    defaultValues.txtTanNo = data.tan_no;
    defaultValues.txtBankName = data.bank_name;
    defaultValues.txtBranch = data.bic;
    defaultValues.txtAccountNo = data.account_number;
    defaultValues.txtAccountName = data.account_name;
    defaultValues.txtIfscCode = data.iban_code;
    defaultValues.txtTrnNumber = data.trn_number;
    reset({ ...defaultValues });
  };

  const childRef = useRef();

  return (
    <>
      <Layout>
        <Grid className="employee-form">
          <AlertMessage ref={childRef} />
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                Edit Company
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">Company</Typography>
                <Typography color="text.primary">Edit</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="secondary"
                className="button_first"
                href="/manage-companies/list"
              >
                List Company
              </LoadingButton>
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>

          <form className="form_design" onSubmit={handleSubmit(onSubmit)}>
            {/* Company Name & Address */}
            <h3>Company Name & Address</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-simple-select-label">
                  Company Name
                </InputLabel> */}
                  <TextField
                    name="txtCompanyName"
                    type="text"
                    label="Company Name"
                    fullWidth
                    focused
                    {...register("txtCompanyName")}
                    error={errors.txtCompanyName ? true : false}
                    helperText={errors.txtCompanyName?.message}
                  />
                </FormControl>
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="address"
                  type="text"
                  label="Street Address"
                  fullWidth
                  focused
                  {...register("txtAddress")}
                  error={errors.txtAddress ? true : false}
                  helperText={errors.txtAddress?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="city"
                  type="text"
                  label="Town / City"
                  fullWidth
                  focused
                  {...register("txtCity")}
                  error={errors.txtCity ? true : false}
                  helperText={errors.txtCity?.message}
                />
              </Grid>

              <Grid item xs={12} lg={6} md={6}>
                <Controller
                  name="txtState"
                  control={control}
                  defaultValue="" // Add this line
                  rules={{ required: "Emirate is required" }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      select
                      label="Emirate"
                      error={!!errors.txtState}
                      helperText={errors.txtState?.message}
                    >
                      {emirates.map((emirate) => (
                        <MenuItem key={emirate.id} value={emirate.name}>
                          {emirate.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Pincode"
                  type="number"
                  label="P.O.Box"
                  fullWidth
                  focused
                  {...register("intPincode")}
                  error={errors.intPincode ? true : false}
                  helperText={errors.intPincode?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Primary phone number"
                  type="text"
                  label="Primary Contact Number"
                  fullWidth
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  }}
                  {...register("txtPrimaryPhoneNumber", {
                    required: "Primary phone number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Phone number must be exactly 10 digits",
                    },
                  })}
                  focused
                  {...register("txtPrimaryPhoneNumber")}
                  error={errors.txtPrimaryPhoneNumber ? true : false}
                  helperText={errors.txtPrimaryPhoneNumber?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Secondary phone number"
                  type="text"
                  label="Secondary phone number"
                  fullWidth
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 10,
                  }}
                  {...register("txtSecondaryPhoneNumber", {
                    pattern: {
                      value: /^[0-9]{0,10}$/,
                      message: "Phone number must be up to 10 digits",
                    },
                  })}
                  focused
                  {...register("txtSecondaryPhoneNumber")}
                  error={errors.txtSecondaryPhoneNumber ? true : false}
                  helperText={errors.txtSecondaryPhoneNumber?.message}
                />
              </Grid>

              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Company email id"
                  type="text"
                  label="Company Email Id"
                  fullWidth
                  focused
                  {...register("txtEmailId")}
                  error={errors.txtEmailId ? true : false}
                  helperText={errors.txtEmailId?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="Website Link"
                  type="text"
                  label="Website Link"
                  fullWidth
                  focused
                  {...register("txtWebsiteLink")}
                  error={errors.txtWebsiteLink ? true : false}
                  helperText={errors.txtWebsiteLink?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="TRN"
                  type="text"
                  label="TRN"
                  fullWidth
                  focused
                  {...register("txtTrnNumber")}
                  error={errors.txtTrnNumber ? true : false}
                  helperText={errors.txtTrnNumber?.message}
                />
              </Grid>
            </Grid>

            {/* Business details */}
            <h3>Business Details</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="gstNo"
                  type="text"
                  label="VAT No."
                  fullWidth
                  inputProps={{ inputMode: "numeric", maxLength: 15 }}
                  focused
                  {...register("txtGstNo")}
                  error={errors.txtGstNo ? true : false}
                  helperText={errors.txtGstNo?.message}
                />
              </Grid>
            </Grid>
            <div className="empty-space-20"></div>

            {/* Bank details */}
            <h3>Bank Details</h3>
            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="bank_name"
                  type="text"
                  label="Bank Name"
                  fullWidth
                  focused
                  {...register("txtBankName")}
                  error={errors.txtBankName ? true : false}
                  helperText={errors.txtBankName?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="account_name"
                  type="text"
                  label="Account Holder"
                  fullWidth
                  focused
                  {...register("txtAccountName")}
                  error={errors.txtAccountName ? true : false}
                  helperText={errors.txtAccountName?.message}
                />
              </Grid>
            </Grid>
            <div className="empty-space-20"></div>

            <Grid container spacing={2}>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="branch"
                  type="text"
                  label="BIC"
                  fullWidth
                  focused
                  {...register("txtBranch")}
                  error={errors.txtBranch ? true : false}
                  helperText={errors.txtBranch?.message}
                />
              </Grid>
              <Grid item className="form-lable" xs={12} lg={6} md={6}>
                <TextField
                  name="ifsc_code"
                  type="text"
                  label="IBAN Code"
                  fullWidth
                  focused
                  {...register("txtIfscCode")}
                  error={errors.txtIfscCode ? true : false}
                  helperText={errors.txtIfscCode?.message}
                />
              </Grid>
            </Grid>

            <div className="empty-space-20"></div>

            {/* Logo Part */}
            <h3>ADD LOGO</h3>
            <Grid item className="avatar-profile" alignItems="left">
              <Grid alignItems="center">
                <Grid className="profile_upload">
                  <Button variant="contained" component="label">
                    Upload
                    <input
                      {...register("txtCoLogo")}
                      onChange={(e) => {
                        uploadImage(e);
                      }}
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                    />
                  </Button>
                </Grid>
                <img className="company_avatar_img" src={baseImage} alt="" />
                <h5 color="black">Upload Company Logo</h5>
                <Typography className="note">
                  Allowed *.jpeg, *.jpg, *.png
                </Typography>
              </Grid>
            </Grid>

            {/* Button */}
            <Grid container className="submit-button" alignItems="center">
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                display="flex"
                justifyContent="center"
              >
                <LoadingButton
                  size="large"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={formState.isSubmitting}
                >
                  Submit
                </LoadingButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Layout>
    </>
  );
}

export default ManageCoEdit;
